import React from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import HelpButton from "../HelpContent/HelpButton";
import MyIcon from "../Common/MyIcon";
import WhatsAppIcon from "../../assets/icons/whatsapp.svg2";

export default function WhatsAppSettings({
  handleCommunicationDefaults,
  communicationDefaults,
  setCommunicationDefaults,
}) {
  return (
    <div>
      <>
        <h5 className="d-flex align-items-center">
          <MyIcon Icon={WhatsAppIcon} width={35} className="me-2" />
          <span className="ms-2">
            <span className="fw-bold me-2">What's App Send Settings:</span>
            <HelpButton helpKey="settings-whatsApp-send-settings" />
            <div className="small text-secondary">
              These settings control options related to outbound whatsapp
              message sending.
            </div>
          </span>
        </h5>
      </>
      <hr className="my-3 text-secondary" />
      <div className="row">
        <div className="col-6">
          <FloatingLabel label="Intro Message:" className="mb-2">
            <Form.Control
              placeholder="Intro message:"
              name="VoiceIntro"
              onChange={handleCommunicationDefaults}
              value={communicationDefaults.VoiceIntro}
              as="textarea"
            />
            <div className="me-2 position-absolute top-50 end-0 translate-middle-y">
              <HelpButton helpKey="settings-whatsApp-send-settings-intro-message" />
            </div>
          </FloatingLabel>
        </div>
        <div className="col-6">
          <FloatingLabel label="Exit Message:" className="mb-2">
            <Form.Control
              placeholder="Exit Message:"
              name="VoiceExit"
              onChange={handleCommunicationDefaults}
              value={communicationDefaults.VoiceExit}
            />
            <div className="me-2 position-absolute top-50 end-0 translate-middle-y">
              <HelpButton helpKey="settings-whatsApp-send-settings-exit-message" />
            </div>
          </FloatingLabel>
        </div>
        <div className="col-6">
          <FloatingLabel label="Voice Retries:" className="mb-2">
            <div className="me-2 position-absolute top-50 end-0 translate-middle-y">
              <HelpButton helpKey="settings-whatsApp-send-settings-voice-retries" />
            </div>
            <Form.Select
              className="border-0"
              placeholder="Voice Retries"
              name="VoiceRetries"
              onChange={handleCommunicationDefaults}
              value={communicationDefaults.VoiceRetries}
            >
              <option value={1}>1</option>
              <option value={2}>2</option>
              <option value={3}>3</option>
            </Form.Select>
          </FloatingLabel>
        </div>
      </div>
    </div>
  );
}
